module.exports = __webpack_public_path__ + "static/img/06.8878473.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour6/06.jpg
// module id = moXp
// module chunks = 0